import React, { useState } from 'react'
import AllCurrencies from '../components/Currency/AllCurrencies'
import CurrencyConverter from '../components/Currency/CurrencyConverter'

function CurrencyPage() {

    const [activeItem, setActiveItem] = useState("1")

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    return (
        <div className="container">
            <div className="row my-4">
                <div className="col-6">
                    <button className="btn btn-primary btn-block" onClick={() => toggle("1")}>Valutakalkulator</button>
                </div>
                <div className="col-6">
                    <button className="btn btn-primary btn-block" onClick={() => toggle("2")}>Alle valutaer</button>
                </div>
            </div>
            {activeItem === "1" && <CurrencyConverter />}
            {activeItem === "2" && <AllCurrencies />}
            
        </div>
    )
}
export default CurrencyPage